// extracted by mini-css-extract-plugin
export var change = "_3a-1";
export var changeList = "_3a-0";
export var changePath = "_3a-2";
export var diffArrow = "_3a-5";
export var diffRow = "_3a-3";
export var diffValue = "_3a-4";
export var error = "_3a-8";
export var notice = "_3a-9";
export var result = "_3a-6";
export var success = "_3a-7";